export const UskinnedBaseBtnClassNames =
  'btn btn-sm base-btn-bg base-btn-bg-solid base-btn-bg-hover-solid base-btn-text base-btn-borders';
